import marked from 'marked';

export default {
  toHtml(md: string): string {
    return marked(md);
  },
};
